import { atom } from "jotai";
import moment from "moment";

const projectDeadlineAtom = atom(0);
projectDeadlineAtom.debugLabel = "Collab Duration";

const hardSkillsAtom = atom([]);
hardSkillsAtom.debugLabel = "Project Branch";

const offeredWorkingTypeAtomNewArray = atom([]);
offeredWorkingTypeAtomNewArray.debugLabel = "Offered Working Type";

const offeredWorkingTypeActiveOptionsAtom = atom([]);
offeredWorkingTypeActiveOptionsAtom.debugLabel =
  "Offered Working Type Active Options";

const descriptionAtom = atom("");
descriptionAtom.debugLabel = "Description";

export {
  projectDeadlineAtom,
  hardSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  descriptionAtom
};
